import {Button, Col, Input, message, Modal, QRCode, Row, Space} from "antd";
import {useRecoilValue} from "recoil";
import {globalReferralSettingState, globalUserDetailState,} from "../../../../_common/global_state";
import {useTranslation} from "react-i18next";
import copy from "copy-to-clipboard";

const QrModal = (props) => {
    const {isModalOpen, handleCancel} = props;
    const {t} = useTranslation();

    const userDetails = useRecoilValue(globalUserDetailState);
    const qrReferral = useRecoilValue(globalReferralSettingState);

    const mainDomain = window.location.hostname.split(".").slice(-2).join(".");

    const homePageUrl = "https://" + mainDomain + "/?affiliate=" + userDetails?.affiliateCode;
    const liveUrl = "https://member." + mainDomain + "/#/register?type=individual&affiliate=" + userDetails?.affiliateCode;
    const demoUrl = "https://member." + mainDomain + "/#/register?type=demo&affiliate=" + userDetails?.affiliateCode;

    const copyLink = (link) => {
        copy(link);
        message.success(t("user.successMsg.affiliateLinkCopiedToClipboard"));
    };

    return (
        <Modal
            title={t("referral.modal.title")}
            open={isModalOpen}
            footer={null}
            onCancel={handleCancel}
            className={"l-1 modalQr"}
            getContainer={() => document.getElementById("layout-1")}
        >
            <Row
                gutter={[16, 16]}
                className={"mt-12 text-center mb-12 justify-center"}
            >
                {qrReferral?.referralLink && (
                    <Col xs={24} md={8} className={"mb-4 md:mb-0"}>
                        <div className={"qr-wrap"}>
                            <h5 className={"qrTitle"}>{t("referral.homepage")}</h5>
                            <Space.Compact className={"w-full mb-4"}>
                                <Input defaultValue={homePageUrl} readOnly/>
                                <Button
                                    type={"primary"}
                                    onClick={() => copyLink(homePageUrl)}
                                >
                                    {t("common.copy")}
                                </Button>
                            </Space.Compact>
                            <div className={"header-qr-container"}>
                                <QRCode value={homePageUrl}/>
                            </div>
                        </div>
                    </Col>
                )}
                {qrReferral?.liveReferralLink && (
                    <Col xs={24} md={8} className={"mb-4 md:mb-0"}>
                        <div className={"qr-wrap"}>
                            <h5 className={"qrTitle"}>{t("referral.live")}</h5>
                            <Space.Compact className={"w-full mb-4"}>
                                <Input defaultValue={liveUrl} readOnly/>
                                <Button
                                    type={"primary"}
                                    onClick={() => copyLink(liveUrl)}
                                >
                                    {t("common.copy")}
                                </Button>
                            </Space.Compact>
                            <div className={"header-qr-container"}>
                                <QRCode value={liveUrl}/>
                            </div>
                        </div>
                    </Col>
                )}
                {qrReferral?.demoReferralLink && (
                    <Col xs={24} md={8}>
                        <div className={"qr-wrap"}>
                            <h5 className={"qrTitle"}>{t("referral.demo")}</h5>
                            <Space.Compact className={"w-full mb-4"}>
                                <Input defaultValue={demoUrl} readOnly/>
                                <Button
                                    type={"primary"}
                                    onClick={() => copyLink(demoUrl)}
                                >
                                    {t("common.copy")}
                                </Button>
                            </Space.Compact>
                            <div className={"header-qr-container"}>
                                <QRCode value={demoUrl}/>
                            </div>
                        </div>
                    </Col>
                )}
            </Row>
        </Modal>
    );
};

export default QrModal;
